import { Box, Flex } from "@chakra-ui/react";
import { Col, Row } from "antd";
import { ContaForm } from "features/conta/typings";
import { Control, UseFormSetValue } from "react-hook-form";
import Field from "components/Input/Field";
import InputToggleContent from "components/Input/InputToggleContent";
import { InputBaseWrapper } from "./InputBaseWrapper";
import OutlineButton from "components/Button/OutlineButton";
import { BsPlusLg } from "react-icons/bs";
import ModalRetencaoImposto from "./ModalRetencaoImposto";
import { useState, useEffect } from "react";
import { RetencaoImpostoItem } from "core/features/conta/typings/index";
import CardRetencaoImposto from "./CardRetencaoImposto";
import colors from "core/resources/theme/colors";
import { FaRegTimesCircle } from "react-icons/fa";

interface RetencaoImpostoProps {
  control: Control<ContaForm, object>;
  form: ContaForm;
  setValue: UseFormSetValue<ContaForm>;
  total: number;
}
function RetencaoImposto({
  control,
  form,
  setValue,
  total,
}: RetencaoImpostoProps) {
  const [indexEdit, setIndexEdit] = useState<number | undefined>();
  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    if (indexEdit !== undefined) {
      setIsOpenModal(true);
    }
  }, [indexEdit]);

  useEffect(() => {
    if (!isOpenModal) {
      setIndexEdit(undefined);
    }
  }, [isOpenModal]);

  const onRemoveItem = (index: number) => {
    const copy = [...form.retencoesImpostos];

    copy.splice(index, 1);

    setValue("retencoesImpostos", copy);
  };

  const defaultDataModal =
    indexEdit !== undefined ? form.retencoesImpostos?.[indexEdit] : undefined;

  return (
    <Box as={Row} mb={2}>
      <Box as={Col} sm={24}>
        <Field
          shouldUnregister
          control={control}
          name="reterImpostos"
          render={({ field }) => (
            <InputToggleContent
              label="Retenção de imposto"
              active={field.value}
              onToggle={field.onChange}
              size="sm"
              buttonIcon={
                <OutlineButton
                  h="32px"
                  onClick={(ev) => {
                    ev.stopPropagation();
                    setIsOpenModal(true);
                  }}
                >
                  <BsPlusLg /> Adicionar
                </OutlineButton>
              }
            >
              <>
                <InputBaseWrapper gutter={16} mb={8}>
                  <Box w="100%">
                    {form.reterImpostos &&
                      form.retencoesImpostos?.map(
                        (item: RetencaoImpostoItem, index) => (
                          <Flex as={Row} gutter={16} key={index}>
                            <Flex as={Col} md={22}>
                              <Flex
                                w="100%"
                                onClick={() => setIndexEdit(index)}
                                cursor="pointer"
                              >
                                <CardRetencaoImposto item={item} />
                              </Flex>
                            </Flex>

                            <Flex as={Col} m="auto" md={2}>
                              <Flex
                                justifyContent="flex-end"
                                cursor="pointer"
                                onClick={() => onRemoveItem(index)}
                              >
                                <FaRegTimesCircle
                                  color={colors.red}
                                  size={24}
                                />
                              </Flex>
                            </Flex>
                          </Flex>
                        )
                      )}
                  </Box>
                </InputBaseWrapper>
              </>
            </InputToggleContent>
          )}
        />
      </Box>
      <ModalRetencaoImposto
        onClose={() => setIsOpenModal(false)}
        open={isOpenModal}
        total={total}
        isEdit={indexEdit !== undefined}
        defaultData={defaultDataModal}
        onSubmit={(item) => {
          const items = form.retencoesImpostos;

          if (indexEdit !== undefined) {
            const copy = [...items];

            copy[indexEdit] = item;

            setValue("retencoesImpostos", copy);
          } else {
            const newItems = items.concat(item);

            setValue("retencoesImpostos", newItems);
          }
          setIsOpenModal(false);
        }}
      />
    </Box>
  );
}

export default RetencaoImposto;
